export default __webpack_public_path__ + "static/media/IFBA-logo.a218ea64.png";